import React from "react";
const Dashboard = () => {
  return (
    <div className="content-wrapper">
      <h3 className="custom-page-title">Dashboard</h3>
    </div>
  );
};

export default Dashboard;
